import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'
import FormatUtils from '@front/squirtle/utils/format'

import Callbacks from './callbacks'


const withContainer = Component => props => {
  const [SUPPORTED_LANGUAGES] = hooks.useSetting('supported_languages')
  const [record_id] = hooks.useFormState('record_id')
  const [isReadOnly] = hooks.useFormState('isReadOnly')
  const [isManagingRecord] = hooks.useFormState('isManagingRecord')
  const [, { openDialog }] = hooks.useDialogs()
  const [, setSuspendedState] = hooks.useFormState('suspended')
  const [status] = hooks.useFieldValues(['status'])

  const verifyClientId = useCallback(hooks.useRecordExist('company', 'client_id'), [])
  const statusChange = useCallback(Callbacks.statusChangeHandler(openDialog, setSuspendedState), [openDialog, setSuspendedState])
  const statusColor = FormatUtils.getStatusColor(status)

  const languages = _.map(SUPPORTED_LANGUAGES, lang => ({ label: _.capitalize(lang), value: lang }))
  const mergedProps = {
    record_id,
    isReadOnly,
    languages,
    isManagingRecord,
    verifyClientId,
    statusChange,
    statusColor
  }

  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
